const Result = {
    success(data,message,response) {
        return {
            'type': 'success',
            'data': data,
            'message': message,
            'response': response,
        }
    },
    error(error,message,response) {
        return {
            'type': 'error',
            'error': error,
            'message': message,
            'response': response,
        }
    },
};

export default Result;